import { Injectable } from '@angular/core';
import Axios from 'axios';
import { SliderDto } from '../dtos/sliderDto';
import { BankDto } from '../dtos/bankDto';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment'
import { StaticPageCreateDto } from '../dtos/staticPage/staticPageCreateDto';
import { StaticPageUpdateDto } from '../dtos/staticPage/staticPageUpdateDto';
import { PageType } from '../enums/pageType';

@Injectable({
    providedIn: 'root',
})
export class BankService {
 
    constructor(private http: HttpClient) { }
      
    public apiUrl = `${environment.apiUrl}/AdminDatas/`;
    
    private getHeaders() {
        const token = sessionStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }

    async getBankaInfo(): Promise<BankDto[]> {
        const { data } = await Axios.get(`${this.apiUrl}getOdeme`, {
            headers: this.getHeaders()
        });
        return data;
    }

    async saveBankaInfo(infos: BankDto[]): Promise<void> {
        await Axios.post(`${this.apiUrl}saveOdeme`, infos, {
            headers: this.getHeaders()
        });
    }
}